import { ButtonGroup, Popper } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "KSplitButton";
var buttonGroupClasses = {
    valueButton: "".concat(PREFIX, "-valueButton")
};
var StyledButtonGroup = styled(ButtonGroup)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            "& *:focus": {
                outline: "1px solid ".concat(theme.palette.primary.main)
            }
        },
        _b["& .".concat(buttonGroupClasses.valueButton)] = {
            "& .MuiButton-label": {
                whiteSpace: "nowrap"
            }
        },
        _b);
});
var StyledPopper = styled(Popper)(function (_a) {
    var theme = _a.theme;
    return ({
        zIndex: theme.zIndex.drawer + 1,
        "& *:focus": {
            outline: "1px solid ".concat(theme.palette.primary.main)
        }
    });
});

export { StyledPopper, buttonGroupClasses, StyledButtonGroup as default };
//# sourceMappingURL=index.styled.js.map
